import { Component, Input, OnChanges } from "@angular/core";
import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-track-history",
	templateUrl: "./track-history.component.html",
	styleUrls: ["./track-history.component.scss"]
})
export class TrackHistoryComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	rotor: APIResults.Rotor;
	@Input()
	regimeConfigs: APIResults.RegimeIndex;

	public regimeCounts: APIResults.RegimeCount[] = undefined;
	public selectedRegimes: number[];

	public timelineOptions: Highcharts.Options;

	public adjustments: APIResults.AdjustmentHistory[];
	public blades: string;

	constructor(public api: ApiService, private charting: ChartingService) { }

	async ngOnChanges() {
		await this.updateAdjustments();
		await this.loadRegimes();
	}

	// When first loaded or upstream params (sensor, order) change
	async loadRegimes() {
		const newCounts = await this.api.GetTrackHistoryCounts(this.asset.asset_id, this.rotor.rotorid);
		if (this.selectedRegimes) {
			// Carry over current selection
			for (const recheck of this.selectedRegimes) {
				const sameRegime = newCounts.find(item => item.regime_id === recheck);
				if (sameRegime) {
					sameRegime.evaluate = true;
				}
			}
		} else {
			// Populate selection with default regimes
			let evalempty = true;
			for (const regime of newCounts) {
				const config = this.regimeConfigs[regime.regime_id];
				if (config) {
					regime.evaluate = config.default;
				}
				if (regime.evaluate) {
					evalempty = false;
				}
			}
			// If no default regimes available, select last one
			if (evalempty && newCounts.length) {
				newCounts[newCounts.length - 1].evaluate = true;
			}
		}
		this.regimeCounts = newCounts;
		await this.regimesChange();
	}

	async regimesChange() {
		this.selectedRegimes = this.regimeCounts.filter(item => item.evaluate).map(item => item.regime_id);
		await this.updatePlots();
	}

	async updatePlots() {
		if (!this.selectedRegimes || !this.selectedRegimes.length) {
			return;
		}
		this.timelineOptions = undefined;
		const results = await this.api.GetTrackHistory(this.asset.asset_id, this.rotor.rotorid, this.selectedRegimes);
		const timelineSeries: Highcharts.SeriesLineOptions[] = [];
		for (const regimeData of results) {
			let regimeLookup = this.regimeCounts.find(item => item.regime_id === regimeData.regime);
			if (!regimeLookup) regimeLookup = { name: "Unknown regime " + regimeData.regime, regime_id: regimeData.regime, count: 0, evaluate: false };
			const timelinePoints: any[] = [];
			for (const row of regimeData.rows) {
				timelinePoints.push({ x: row[0] * 1000, y: row[1] });
			}
			timelineSeries.push({
				name: regimeLookup.name,
				type: "line",
				data: timelinePoints,
			});
		}
		this.timelineOptions = this.charting.RTBHistoryTimelineDefaults(timelineSeries, "Split (mm)", this.fleet ? this.fleet.time_offset_hours : 0, this.adjustments, undefined, this);
	}

	async updateAdjustments() {
		const result = await this.api.GetAdjustmentHistory(this.asset.asset_id, this.rotor.rotorid);
		this.adjustments = result;
		this.blades = this.rotor.blade.map(item => item.name).join(", ");
	}

	async DeleteAdjustment(id: number) {
		await this.api.DeleteAdjustment(this.asset.asset_id, id);
		await this.updateAdjustments();
		this.timelineOptions = undefined;
		await this.regimesChange();
	}
}
